// Edit-mode toolbar for the design page: an add palette plus the two save paths
// (re-run = engine re-derives cabling around the edited topology; manual save =
// freeze the edited topology as-is, flagged "needs recompute") and cancel.
// Cohesive with the dark-glass control panel; RTL, high-contrast, no em dash.

const ADD_TYPES = [
  { k: 'olt', label: 'سایت', c: '#16a34a' },
  { k: 'odc', label: 'ODC', c: '#06b6d4' },
  { k: 'fat', label: 'FAT', c: '#2563eb' },
  { k: 'hh', label: 'HH', c: '#1e3a8a' },
];

export default function DesignEditToolbar({ editType, onArmType, onApplyRerun, onSaveManual, onCancel, busy, msg }) {
  return (
    <div style={{ direction: 'rtl', fontFamily: "'Vazirmatn', sans-serif", display: 'flex',
      flexDirection: 'column', gap: 10, padding: 14, borderRadius: 12, color: '#e2e8f0',
      background: 'linear-gradient(135deg, rgba(13,148,136,0.16), rgba(15,23,42,0.96))',
      border: '1px solid rgba(45,212,191,0.32)' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontWeight: 800, fontSize: 13, color: '#5eead4' }}>
        <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#2dd4bf', boxShadow: '0 0 8px #2dd4bf' }} />
        حالتِ ویرایش
      </div>
      <div style={{ fontSize: 11, color: '#cbd5e1', lineHeight: 1.75 }}>
        عنصر را بکش تا جابه‌جا شود؛ روی آن کلیک کن تا حذف شود؛ یا یک نوع را انتخاب کن و روی نقشه بزن تا اضافه شود.
      </div>

      <div>
        <div style={{ fontSize: 11, fontWeight: 700, color: '#94a3b8', marginBottom: 6 }}>افزودنِ عنصر:</div>
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          {ADD_TYPES.map(({ k, label, c }) => {
            const on = editType === k;
            return (
              <button key={k} type="button" onClick={() => onArmType(on ? null : k)} aria-pressed={on}
                style={{ flex: '1 1 52px', minWidth: 52, padding: '7px 9px', borderRadius: 8, cursor: 'pointer',
                  fontWeight: 700, fontSize: 12, fontFamily: "'Vazirmatn', sans-serif",
                  color: on ? '#0b1220' : '#cbd5e1', background: on ? c : 'rgba(51,65,85,0.55)',
                  border: `1px solid ${on ? c : 'rgba(148,163,184,0.28)'}`, transition: '0.14s' }}>
                {label}
              </button>
            );
          })}
        </div>
        {editType && (
          <div style={{ fontSize: 10.5, color: '#5eead4', marginTop: 6 }}>
            روی نقشه بزن تا یک {ADD_TYPES.find((t) => t.k === editType).label} اضافه شود.
          </div>
        )}
      </div>

      <button type="button" onClick={onApplyRerun} disabled={busy}
        style={{ padding: '9px 14px', borderRadius: 9, fontWeight: 700, fontSize: 12.5,
          fontFamily: "'Vazirmatn', sans-serif", cursor: busy ? 'wait' : 'pointer', color: '#0b1220',
          background: 'linear-gradient(135deg,#2dd4bf,#0d9488)', border: 'none' }}>
        {busy ? 'در حال پردازش…' : 'اعمال و اجرای مجدد'}
      </button>
      <div style={{ fontSize: 10, color: '#94a3b8', lineHeight: 1.6, marginTop: -4 }}>
        موتور کابل‌کشی، هندهول و بودجهٔ نوری را برای چیدمانِ شما از نو محاسبه می‌کند.
      </div>

      <button type="button" onClick={onSaveManual} disabled={busy}
        style={{ padding: '8px 12px', borderRadius: 9, fontWeight: 700, fontSize: 12,
          fontFamily: "'Vazirmatn', sans-serif", cursor: busy ? 'wait' : 'pointer', color: '#e2e8f0',
          background: 'rgba(51,65,85,0.7)', border: '1px solid rgba(148,163,184,0.32)' }}>
        ذخیرهٔ ویرایشِ دستی (بدون اجرا)
      </button>
      <div style={{ fontSize: 10, color: '#94a3b8', lineHeight: 1.6, marginTop: -4 }}>
        چیدمان دقیقاً حفظ می‌شود؛ ولی کابل‌کشی و فیزیبیلیتی نیازمندِ محاسبهٔ مجدد خواهند بود.
      </div>

      <button type="button" onClick={onCancel} disabled={busy}
        style={{ padding: '8px 12px', borderRadius: 9, fontWeight: 700, fontSize: 12,
          fontFamily: "'Vazirmatn', sans-serif", cursor: busy ? 'wait' : 'pointer', color: '#cbd5e1',
          background: 'transparent', border: '1px solid rgba(148,163,184,0.28)' }}>
        لغوِ ویرایش
      </button>

      {msg && (
        <div style={{ fontSize: 11.5, fontWeight: 700, color: msg.ok ? '#86efac' : '#fca5a5' }}>{msg.t}</div>
      )}
    </div>
  );
}
